import { z } from "zod";
import { schemes } from "../schema-validation";
import { ECustomerAccountSection } from "./ECustomerAccountSection";

export const customerAccountSectionSchema = z.object({
  name: z.nativeEnum(ECustomerAccountSection),
});

export const customerAccountShareableLinksTokenPayloadSchema = z.object({
  companyID: schemes.companyID(),
  customerAccountID: z.string(),
  isShareableLink: z.literal(true),
  sections: z.array(customerAccountSectionSchema),
  testMode: z.boolean(),
  whiteLabelID: z.string(),
});

export const customerAccountInformationCompanySchema = z.object({
  company_id: schemes.companyID(),
  business_name: z.string(),
});

export const customerAccountInformationPayloadSchema = z.object({
  company: customerAccountInformationCompanySchema,
  logoURL: z.string().nullish(),
  tokenPayload: customerAccountShareableLinksTokenPayloadSchema,
});

export type TCustomerAccountShareableLinksSection = z.infer<
  typeof customerAccountSectionSchema
>;
export type TCustomerAccountShareableLinksTokenPayload = z.infer<
  typeof customerAccountShareableLinksTokenPayloadSchema
>;
export type TCustomerAccountInformationPayload = z.infer<
  typeof customerAccountInformationPayloadSchema
>;
